import { createSlice } from "@reduxjs/toolkit";
import {
  AuthenticatedUser,
  LoginForm,
  LoginState,
  ServerError,
  User,
} from "../types/index.js";
import { copiedModuleClipboard, fetch, isWretchError } from "../utils/utils.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "login";

const initialState: LoginState = { isSubmitting: false, error: undefined };

export const postLogin = createAppAsyncThunk<
  User,
  LoginForm,
  { rejectValue: ServerError }
>(`${sliceName}/postLogin`, async (form, { dispatch, rejectWithValue }) => {
  try {
    const user = await fetch({ dispatch })
      .post(form, "users/login")
      .json<AuthenticatedUser>();
    window.localStorage.setItem("user", JSON.stringify(user));

    copiedModuleClipboard.clear();

    return user;
  } catch (error) {
    if (isWretchError<ServerError>(error) && error.json) {
      return rejectWithValue(error.json);
    }
    throw error;
  }
});

const loginSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(postLogin.pending, (state) => {
      state.isSubmitting = true;
    });
    builder.addCase(postLogin.fulfilled, (state) => {
      state.isSubmitting = false;
    });
    builder.addCase(postLogin.rejected, (state, action) => {
      state.isSubmitting = false;
      if (action.meta.rejectedWithValue) {
        state.error = action.payload;
      }
    });
  },
});

export default loginSlice.reducer;
